import { api } from '@/modules/apiv2';

const CACHE_DURATION_MS = 20 * 60 * 1000; // 20 minutes in milliseconds

export default {
  state: {
    templates: [],
    sasUriCache: {}, // Cache for SAS URIs: { [uri]: { sasUri: string, timestamp: number } }
  },

  getters: {
    templates(state) {
      return state.templates;
    },
  },

  mutations: {
    setTemplates(state, templates) {
      state.templates = templates;
    },
    addTemplate(state, template) {
      state.templates.push(template);
    },
    setSasUriCache(state, { uri, sasUri, timestamp }) {
      state.sasUriCache[uri] = { sasUri, timestamp };
    },
  },

  actions: {
    async getTemplates({ commit, getters, state }) {
      const templatesUrl = `${getters.templatesEndpoint}`;
      let data = await api.get(templatesUrl);
      console.log('Fetched training templates:', data);

      // Get SAS URIs for each video URL
      await Promise.all(
        data.map(async (template) => {
          if (!template) return;

          let [camera1Uri, camera2Uri, camera3Uri, camera4Uri] = await Promise.all([
            fetchSasUriForCamera(template?.camera1VideoUri),
            fetchSasUriForCamera(template?.camera2VideoUri),
            fetchSasUriForCamera(template?.camera3VideoUri),
            fetchSasUriForCamera(template?.camera4VideoUri),
          ]);

          template.camera1SASUri = camera1Uri;
          template.camera2SASUri = camera2Uri;
          template.camera3SASUri = camera3Uri;
          template.camera4SASUri = camera4Uri;
        })
      );

      commit('setTemplates', data);
      return data;

      async function fetchSasUriForCamera(uri) {
        if (uri) {
          // Check cache first
          const cached = state.sasUriCache[uri];
          const now = Date.now();

          if (cached && now - cached.timestamp < CACHE_DURATION_MS) {
            return cached.sasUri;
          }

          // Fetch SAS URI for cameraXVideoUri
          const response = await api.getResponse(`${uri}?noRedirect=true`);
          const result = await response.json();

          // Cache the result
          if (result && result[0]) {
            commit('setSasUriCache', {
              uri,
              sasUri: result[0],
              timestamp: now,
            });
          }

          return result ? result[0] : null;
        } else {
          return null;
        }
      }
    },
  },
};
